const Approval = ({
  handleApproveImport,
  setOpen,
  unresolvedConflictCount = 0,
}) => {
  // The Conflicts step already refuses to hand over while anything is unanswered. This
  // is the second lock on the same door: approving with a conflict unanswered is refused
  // by the backend, so the button must never look like it would work.
  const isBlocked = unresolvedConflictCount > 0;

  return (
    <div className="flex flex-col justify-center items-center h-40 max-w-[650px]">
      <h1 className="mb-2 text-xl">
        {isBlocked ? "Decisions Still Needed" : "Review Completed"}
      </h1>
      <p className="text-lg text-gray-500">
        {isBlocked
          ? unresolvedConflictCount === 1
            ? "Go back to the Conflicts step and choose what to do with the conflicting process version."
            : `Go back to the Conflicts step and choose what to do with the ${unresolvedConflictCount} conflicting process versions.`
          : "You can approve the changes and import the pipeline or you can reject the changes."}
      </p>
      <div className="w-full flex justify-end space-x-4 mb-2">
        <button
          className="inline-flex items-center gap-x-1.5 rounded-md px-3 py-2 text-sm bg-red-600 hover:bg-red-500 focus-visible:outline-red-600 text-white shadow-sm duration-200 ease-in-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
          onClick={() => setOpen(false)}>
          Reject
        </button>
        <button
          disabled={isBlocked}
          data-testid="importApprove"
          className="inline-flex items-center gap-x-1.5 rounded-md px-3 py-2 text-sm bg-green-600 hover:bg-green-500 focus-visible:outline-green-600 text-white shadow-sm duration-200 ease-in-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:bg-gray-400 disabled:cursor-not-allowed disabled:hover:bg-gray-400"
          onClick={handleApproveImport}>
          Approve
        </button>
      </div>
    </div>
  );
};

export default Approval;
